// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-popper {\n  padding: 10px 0;\n}\n.menu-popper .sub-menu-title i {\n    padding-left: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
